module.exports = __webpack_public_path__ + "img/sae.f4c37ba0.svg";